import { render, staticRenderFns } from "./CartV2.vue?vue&type=template&id=337633c0&scoped=true&"
import script from "./CartV2.vue?vue&type=script&lang=js&"
export * from "./CartV2.vue?vue&type=script&lang=js&"
import style0 from "./CartV2.vue?vue&type=style&index=0&id=337633c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337633c0",
  null
  
)

export default component.exports